









































import { Component } from "vue-property-decorator";
import { MenuItem } from "../../Models/Components.model";
import { NavigationService } from "../../NavigationServices/navigation";
import {
	MenuItemDTO,
	ArticleTypeDataArticleType,
	IMenuItemDTO
} from "../../Generated/ParticaAPI";
import EventBus from "../../Plugins/eventbus";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import { State, Action } from "vuex-class";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
const namespace: string = "config";

@Component({
	name: "ParticaTreeMenu",
	components: { ParticaError }
})
export default class ParticaTreeMenu extends ParticaBaseView {
	private items: MenuItemDTO[] = [];
	private openlist: string[] = [];
	private open: string[] = ["site:0"];
	private search: string = "";
	private filter: string = "";
	private svc: NavigationService;
	private async login() {
		this.navigate("/login", undefined);
	}
	private menuclicked(item: any) {
		this.$router.push({ path: item.link }).catch(err => { });
	}
	private async getMenu() {
		try {
			this.LoadingStart("menu");
			if (this.stateconfig.accountid === 0) {
				this.items = await this.svc.getMyMenu();
				if (this.items.length > 0 && this.items[0].id !== undefined) {
					// tslint:disable-next-line
					this.setaccount(parseInt(this.items[0].id));
				}
			} else if (this.stateconfig.accountid === -1) {
				if (localStorage.auth) {
					this.items = await this.svc.getMyMenu();
					if (this.items.length > 0 && this.items[0].id !== undefined) {
						// tslint:disable-next-line
						this.setaccount(parseInt(this.items[0].id));
					}
				}
			} else {
				this.items = await this.svc.getMenu(this.stateconfig.accountid, 0);
			}
		} catch (e) {
			this.ShowErrorDialog(e, "Unable to load dashboard menu.");
		} finally {
			this.LoadingEnd("menu");
		}
	}
	private async mounted() {
		this.svc = new NavigationService();
		await this.getMenu();
		EventBus.$on("main-menu-event", async (data: any) =>
			this.handleEvent(data as ParticaEvent)
		);
	}

	private async handleEvent(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.MENU_RELOAD: {
					await this.getMenu();
					if (event.item !== null) {
						// this.openlist.push(event.item);
					}
					break;
				}
				case eParticaAction.MY_MENU_RELOAD: {
					this.setaccount(0);
					await this.getMenu();
					if (event.item !== null) {
						// this.openlist.push(event.item);
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (e) {
			this.ShowErrorDialog(e, "unhandled event. " + event.action);
		}
	}

}
